import { Theme } from '@mui/material/styles'

const useStyles = {
  gaugeContainer: {
    position: 'relative',
    width: '260px',
    display: 'flex',
    justifyContent: 'center',
  },
  gaugeFooter: {
    position: 'absolute',
    bottom: '5px',
    left: '37px',
  },
  gaugeFooterCount: (theme: Theme) =>
    ({
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '21px',
      letterSpacing: '0.4px',
      color: theme.palette.blue.variant3,
      textAlign: 'center',
    }) as const,
  gaugeFooterLabel: (theme: Theme) =>
    ({
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '19px',
      letterSpacing: '0.4px',
      color: theme.palette.secondary.light,
      textAlign: 'center',
    }) as const,
}

export default useStyles
